// @ts-nocheck
import Styleguide from "@toolkit/Framework/Types/Styleguide";

const colors: Styleguide["colors"] = {
    primary: {
        main: "#1971D4",
        contrast: "#ffffff",
        dark: "#1C53A6",
        light: "#E1E3ED",
    },
    secondary: {
        main: "#001046",
        contrast: "#ffffff",
        // custom
        dark: "#171A35",
        light: "#EEF1FD",
    },
    tertiary: {
        main: "#5FD400",
        contrast: "#ffffff",
        dark: "#265917",
        light: "#E4F2DB",
    },
    common: {
        background: "#ffffff",
        checkboxPickerBackground: "#ecedee",
        backgroundContrast: "#505D67",
        backgroundContrastLight: "#f5f7f8",
        backgroundColorWarmGrey: "#718096",
        backgroundColorLightWarmGrey: "#E2E8F0",
        whiteAlpha800: "RGBA(255, 255, 255, 0.8)",
        accent: "#F3F5F7",
        accentContrast: "#505D67",
        border: "#DBE0E6",
        disabled: "#DBE0E6",
        // Custom
        accentLighter: "#F8F8F8",
        customFocus: "#4287f5",
        backgroundRgba: "rgba(255, 255, 255, 0.9)",
        borderLight: "#DCDDE6",
        borderDark: "#ADADAC",
        borderColored: "#001046",
        disabledLighter: "#F8F8F8",
        disabledLight: "#F3F5F7",
        shadesLight: "#F7F8F9",
        shadesMedium: "#EBECEC",
        shadesMain: "#202B33",
        shadesDark: "#07080A",
        shadow: "#ACA8A8",
    },
    text: {
        contractPricing: "#805ad5",
        whiteAlpha900: "RGBA(255, 255, 255, 0.9)",
        main: "#404040",
        disabled: "#DBE0E6",
        accent: "#5C6163",
        link: "#1971D4",
        linkDark: "#159DFF",
        titleTextLightGray: "rgb(13, 44, 107)",
        // Custom
        darkAccent: "#ced6de",
        milanoRed: "#B12704",
        dark: "#36404C",
        darkest: "#333333",
        linkHover: "#033873",
        input: "#666666",
    },
    /* Store Custom Code - Start */
    success: {
        main: "#116932",
        contrast: "#ffffff",
        light: "#dcfce7",
    },
    danger: {
        main: "#991919",
        contrast: "#ffffff",
        light: "#fee2e2",
    },
    warning: {
        main: "#92310a",
        contrast: "#ffffff",
        light: "#ffedd5",
    },
    info: {
        main: "#173da6",
        contrast: "#EEF9FF",
        light: "#DBEAFE",
        // Custom
        alt: "#DCE2F1",
    },
    /* Store Custom Code - End */
    menu: {
        mainNavigation: {
            main: "#ffffff",
            contrast: "#0D2C6B",
            hover: "#2F6E1C",
            accent: "#0D2C6B",
            accentContrast: "#ffffff",
            accentHover: "#0D2C6B",
            border: "#DBE0E6",
        },
        secondaryNavigation: {
            main: "#505D67",
            contrast: "#505D67",
            hover: "#505D67",
        },
    },
    footer: {
        main: "#ffffff", // Gray Shades -> Light
        contrast: "#505D67", // Text Color -> Main
        alt: "#F8F8F8", // Primary -> Main
        altContrast: "#505D67", // None, should match "primary.contrast"
    },
};

export default colors;
